import VendorSignupView from '@/views/vendors/VendorSignup.vue'
import VendorOnboardView from '@/views/vendors/VendorOnboard.vue'
import DashboardLayoutView from '@/views/vendors/DashboardLayout.vue'
import DashboardHomeView from '@/views/vendors/DashboardHome.vue'
import DashboardVenuesView from '@/views/vendors/DashboardVenues.vue'
import DashboardPackagesView from '@/views/vendors/DashboardPackages.vue'
import DashboardSettingsView from '@/views/vendors/DashboardSettings.vue'
import DashboardProfileView from '@/views/vendors/DashboardProfile.vue'
import DashboardChangePasswordView from '@/views/vendors/DashboardChangePassword.vue'
import DashboardInfoPageView from '@/views/vendors/DashboardInfoPage.vue'
import BusinessEditorView from '@/views/vendors/BusinessEditor.vue'
import BusinessDetailView from '@/views/vendors/BusinessDetail.vue'
import VenueDetailView from '@/views/vendors/VenueDetail.vue'
import BusinessModuleEditorView from '@/views/vendors/BusinessModuleEditor.vue'
import AddVenueView from '@/views/vendors/AddVenue.vue'
import EditVenueView from '@/views/vendors/EditVenue.vue'
import AddPackageView from '@/views/vendors/AddPackage.vue'
import EditPackageView from '@/views/vendors/EditPackage.vue'

const vendorRoutes = [
  { path: '/business/:id/venues/:venueId', name: 'business-venue-detail', component: VenueDetailView, meta: { layout: 'vendor', requiresAuth: true, allowedRole: 'vendor' } },
  { path: '/vendor-signup', name: 'vendor-signup', component: VendorSignupView, meta: { layout: 'vendor' } },
  { path: '/vendor-onboard', name: 'vendor-onboard', component: VendorOnboardView, meta: { layout: 'vendor' } },
  {
    path: '/dashboard',
    component: DashboardLayoutView,
    meta: { requiresAuth: true, layout: 'vendor', allowedRole: 'vendor' },
    children: [
      { path: '', name: 'dashboard', component: DashboardHomeView },
      { path: 'venues', name: 'dashboard-venues', component: DashboardVenuesView },
      { path: 'packages', name: 'dashboard-packages', component: DashboardPackagesView },
      { path: 'settings', name: 'dashboard-settings', component: DashboardSettingsView },
      { path: 'settings/profile', name: 'dashboard-settings-profile', component: DashboardProfileView },
      { path: 'settings/change-password', name: 'dashboard-settings-change-password', component: DashboardChangePasswordView },
      { path: 'settings/about', name: 'dashboard-settings-about', component: DashboardInfoPageView, meta: { contentKey: 'about' } },
      { path: 'settings/support', name: 'dashboard-settings-support', component: DashboardInfoPageView, meta: { contentKey: 'support' } },
      { path: 'settings/faqs', name: 'dashboard-settings-faqs', component: DashboardInfoPageView, meta: { contentKey: 'faqs' } },
      { path: 'settings/terms', name: 'dashboard-settings-terms', component: DashboardInfoPageView, meta: { contentKey: 'terms' } },
      { path: 'settings/privacy', name: 'dashboard-settings-privacy', component: DashboardInfoPageView, meta: { contentKey: 'privacy' } },
      { path: 'business/new', name: 'business-create', component: BusinessEditorView },
      { path: 'business/:id/view', name: 'business-detail', component: BusinessDetailView },
      { path: 'business/:id', name: 'business-edit', component: BusinessEditorView },
      { path: 'business/:businessId/:moduleType/new', name: 'business-module-create', component: BusinessModuleEditorView },
      { path: 'business/:businessId/:moduleType/:moduleId', name: 'business-module-edit', component: BusinessModuleEditorView },
      { path: 'add-venue', name: 'add-venue', component: AddVenueView },
      { path: 'edit-venue/:id', name: 'edit-venue', component: EditVenueView },
      { path: 'add-package', name: 'add-package', component: AddPackageView },
      { path: 'edit-package/:id', name: 'edit-package', component: EditPackageView }
    ]
  }
]

export default vendorRoutes
